export const bannerList = (state) => {
    return state.banners
}

